import React, {
  useState,
  useRef,
  useEffect,
  useCallback,
  useMemo,
} from "react";
import {
  AppBar,
  Box,
  IconButton,
  InputBase,
  styled,
  Toolbar,
  Typography,
  Button,
  Badge,
  Divider,
  Tooltip,
  Avatar,
  Menu,
  MenuItem,
  Chip,
  Paper,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  CircularProgress,
  Fade,
  Popper,
  ClickAwayListener,
  Snackbar,
  Alert,
  DialogContent,
  Dialog,
  Slide,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import Logo from "../../../assets/images/logo1.png";
import SubcategoryBar from "../SubCategory/Subcategory";
import ProductsGrid from "../ProductGrid/Productgrid";
import {
  Search as SearchIcon,
  Close,
  ShoppingCartOutlined,
  PersonOutline,
  LocationOnOutlined,
  KeyboardArrowDownRounded,
  ChevronLeft,
  ChevronRight,
  Logout,
  MyLocation,
} from "@mui/icons-material";
import SignInLayout from "../SignIn/signin";
import CartDrawer from "../Card/Card";
import { useDispatch, useSelector } from "react-redux";
import { slugify } from "../../../utils/slugify";
import CurrentLocation from "../../common/Location/Location";
import GroceriesBannerSlider from "../GroceriesBanner/GroceriesBannerSlider";
import Footer from "../../common/Footer/Footer";
import searchService from "../../../pages/ProductSearch/ProductSearch";
// import { logout } from "../../../redux/slices/authSlice";
import { clearPincode, setPincode } from "../../../redux/slices/orderSlice";
import { getCartItems } from "../../../services/api/cartService";
import {
  logout,
  setToken,
  setRefreshToken,
  setUser,
  setIsAuthenticated,
} from "../../../redux/slices/authSlice";
// import OrderSuccess from "../../../pages/OrderSuccess/OrderSuccess";
import OrderSuccessPopup from "../../../pages/OrderSuccessPopup/OrderSuccessPopup";
import ConsumerProfile from "../../../pages/ConsumerProfile/consumerprofile";
import VendorShowcase from "../../common/NearByVendor/vendorshowcase";
import VendorCategoryPage from "../VendorCategoryPage/VendorCategoryPage";
import { SignOut } from "../../../services/api/authService";

const getEmojiForCategory = (name) => {
  const map = {
    Food: "🍔",
    Groceries: "🛒",
    Retail: "🛍️",
    Services: "🔧",
    Electronics: "⚡",
    Fruits: "🍎",
    Vegetables: "🥬",
    Dairy: "🥛",
    Snacks: "🍿",
    Beverages: "🥤",
    "Beauty & Cosmetics": "💄",
    "Daily Needs": "🧻",
    "Gifts & Toys": "🎁",
    Stationery: "📚",
  };
  return map[name] || "📦";
};

const getColorForCategory = (name) => {
  const map = {
    Food: "#fff9e6",
    Groceries: "#fff9e6",
    Retail: "#fff0f0",
    Services: "#e8f4fd",
    Electronics: "#e8f4fd",
    Fruits: "#ebfbee",
    Vegetables: "#ebfbee",
    "Beauty & Cosmetics": "#fce4ec",
    Pharmacy: "#e3f2fd",
    Christmas: "#fff3e0",
    "Daily Needs": "#f5f5f5",
    "Gifts & Toys": "#f5f5f5",
    Stationery: "#f5f5f5",
  };
  return map[name] || "#f5f5f5";
};

const getBorderForCategory = (name) => {
  const map = {
    Food: "#f7c948",
    Groceries: "#f7c948",
    Retail: "#ff6b6b",
    Services: "#4dabf7",
    Electronics: "#4dabf7",
    Fruits: "#69db7c",
    Vegetables: "#69db7c",
  };
  return map[name] || "#cccccc";
};

const GlassAppBar = styled(AppBar)({
  background: "linear-gradient(135deg, #f1f0ed 0%, #f0dfac 100%)",
  backdropFilter: "blur(20px)",
  boxShadow: "0 4px 30px rgba(0,0,0,0.15)",
  borderBottom: "1px solid rgba(255,255,255,0.1)",
});

const SearchBar = styled(Box)({
  position: "relative",
  display: "flex",
  alignItems: "center",
  background: "rgba(255,255,255,0.18)",
  backdropFilter: "blur(10px)",
  border: "1.5px solid rgba(255,255,255,0.3)",
  borderRadius: 50,
  flexGrow: 1,
  margin: "0 16px",
  transition: "all 0.3s ease",
  "&:focus-within": {
    background: "rgba(255,255,255,0.28)",
    border: "1.5px solid rgba(255,255,255,0.6)",
    boxShadow: "0 0 0 3px rgba(255,255,255,0.15)",
  },
});

const DeliveryBar = styled(Box)({
  background: "linear-gradient(90deg, #f3de9f 0%, #f3de9f 100%)",
  display: "flex",
  alignItems: "center",
  padding: "0 24px",
  minHeight: 40,
  gap: 12,
  borderBottom: "1px solid rgba(0,0,0,0.07)",
});

const LocationChip = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: 5,
  marginLeft: "auto",
  color: "rgba(0,0,0,0.75)",
  fontSize: 13,
  fontWeight: 600,
  fontFamily: '"Nunito", sans-serif',
  padding: "4px 12px",
  borderRadius: 20,
  background: "rgba(255,255,255,0.45)",
  border: "1px solid rgba(0,0,0,0.1)",
  cursor: "pointer",
  transition: "background 0.2s",
  "&:hover": { background: "rgba(255,255,255,0.7)" },
});

const SignInButton = styled(Button)({
  background: "rgba(255,255,255,0.18)",
  color: "#3a2e00",
  fontWeight: 700,
  fontFamily: '"Nunito", sans-serif',
  fontSize: 13,
  borderRadius: 50,
  padding: "6px 18px",
  border: "1.5px solid rgba(255,255,255,0.4)",
  textTransform: "none",
  whiteSpace: "nowrap",
  backdropFilter: "blur(6px)",
  transition: "all 0.25s",
  "&:hover": {
    background: "rgba(255,255,255,0.32)",
    border: "1.5px solid rgba(255,255,255,0.7)",
    boxShadow: "0 2px 12px rgba(0,0,0,0.12)",
  },
});

const ProfileButton = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: 8,
  cursor: "pointer",
  padding: "4px 8px",
  borderRadius: 50,
  background: "rgba(255,255,255,0.18)",
  border: "1.5px solid rgba(255,255,255,0.4)",
  transition: "all 0.25s",
  "&:hover": {
    background: "rgba(255,255,255,0.32)",
    border: "1.5px solid rgba(255,255,255,0.7)",
  },
});

const CartButton = styled(IconButton)({
  background: "rgba(255,255,255,0.18)",
  border: "1.5px solid rgba(255,255,255,0.35)",
  backdropFilter: "blur(6px)",
  transition: "all 0.25s",
  "&:hover": { background: "rgba(255,255,255,0.32)", transform: "scale(1.07)" },
});

const StyledAvatar = styled(Avatar)({
  width: 32,
  height: 32,
  background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
  color: "white",
  fontWeight: 600,
  fontSize: 14,
  cursor: "pointer",
});

const SearchResultItem = ({ item, onClick }) => (
  <ListItem
    button
    onClick={() => onClick(item)}
    sx={{
      borderRadius: 2,
      mb: 0.5,
      "&:hover": {
        bgcolor: "#f5f5f5",
        transform: "translateX(4px)",
        transition: "all 0.2s",
      },
    }}
  >
    <ListItemAvatar>
      <Avatar
        src={item.imageUrl}
        sx={{ width: 50, height: 50, borderRadius: 2 }}
      >
        {!item.imageUrl && "📦"}
      </Avatar>
    </ListItemAvatar>
    <ListItemText
      primary={
        <Typography sx={{ fontWeight: 600, fontSize: 14 }}>
          {item.name}
        </Typography>
      }
      secondary={
        <Box sx={{ display: "flex", gap: 1, mt: 0.5 }}>
          <Typography variant="caption" sx={{ color: "#666" }}>
            {item.category}
          </Typography>
          {item.isAvailableToday === 1 && (
            <Typography variant="caption" sx={{ color: "#4caf50" }}>
              • In Stock
            </Typography>
          )}
        </Box>
      }
    />
  </ListItem>
);

function Header({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [search, setSearch] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const searchAnchorRef = useRef(null);
  const searchTimeoutRef = useRef(null);
  const resultsContainerRef = useRef(null);
  const [profileDrawerOpen, setProfileDrawerOpen] = useState(false);
  const user = useSelector((state) => state?.auth?.user);
  console.log("User from Redux:", user);
  const zipcode = useSelector((state) => state.orders?.postalcode);
  const [selectedLocation, setSelectedLocation] = useState(
    "Detecting location...",
  );
  const [currentLocationOpen, setCurrentLocationOpen] = useState(false);
  const [locationLoading, setLocationLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });
  const [activeCategory, setActiveCategory] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubcategory, setSelectedSubcategory] = useState(null);
  const [selectedSubSubcategory, setSelectedSubSubcategory] = useState(null);
  const [subSubcategories, setSubSubcategories] = useState([]);
  const [scrollPos, setScrollPos] = useState(0);
  const scrollRef = useRef(null);
  const [cartCount, setCartCount] = useState(0);
  const [cartDrawerOpen, setCartDrawerOpen] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userName, setUserName] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const contentRef = useRef(null);
  const prevPathRef = useRef(null);
  const cartFetchedRef = useRef(false);
  const locationFetchedRef = useRef(false);
  const [showOrderPopup, setShowOrderPopup] = useState(false);
  const [popupOrderNumber, setPopupOrderNumber] = useState(null);
  const [popupTimeout, setPopupTimeout] = useState(null);
  const popupTimerRef = useRef(null);
  const isVendorPage = location.pathname.startsWith("/vendor/");
  const [vendorId, setVendorId] = useState(null);
  const [vendorName, setVendorName] = useState("");
  const dispatch = useDispatch();
  const categoriesFromRedux = useSelector(
    (state) => state.categories?.categories || [],
  );

  const CATEGORIES = useMemo(
    () =>
      categoriesFromRedux.length > 0
        ? categoriesFromRedux.map((cat) => ({
            label: cat.name,
            emoji: getEmojiForCategory(cat.name),
            color: getColorForCategory(cat.name),
            border: getBorderForCategory(cat.name),
            id: cat.id,
            description: cat.description,
            hasChildren: cat.hasChildren,
            imageUrl: cat.imageUrl,
            slug: slugify(cat.name),
          }))
        : [],
    [categoriesFromRedux],
  );

  useEffect(() => {
    if (isVendorPage) {
      const vendorIdFromPath = location.pathname.split("/")[2];
      setVendorId(vendorIdFromPath);
      const vendorNameFromState = location.state?.vendorName;
      setVendorName(vendorNameFromState || "Vendor Store");
    } else {
      setVendorId(null);
      setVendorName("");
    }
  }, [location.pathname, isVendorPage]);

  const getCurrentLocationAndPincode = useCallback(() => {
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        reject(new Error("Geolocation is not supported by your browser"));
        return;
      }

      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;

          try {
            // Reverse geocoding to get address and pincode
            const response = await fetch(
              `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}&zoom=18&addressdetails=1`,
            );
            const data = await response.json();

            const address = data.address;
            const pincode = address.postcode;
            const city = address.city || address.town || address.village;
            const area =
              address.suburb || address.neighbourhood || address.city_district;

            if (pincode) {
              const locationData = {
                latitude,
                longitude,
                pincode,
                city: city || "Unknown",
                area: area || "Unknown",
                shortAddress: area || city || "Your Location",
                fullAddress: data.display_name,
              };
              resolve(locationData);
            } else {
              reject(new Error("Could not detect pincode for this location"));
            }
          } catch (error) {
            reject(new Error("Error fetching address details"));
          }
        },
        (error) => {
          switch (error.code) {
            case error.PERMISSION_DENIED:
              reject(
                new Error(
                  "Location permission denied. Please enable location access to continue.",
                ),
              );
              break;
            case error.POSITION_UNAVAILABLE:
              reject(new Error("Location information is unavailable"));
              break;
            case error.TIMEOUT:
              reject(new Error("Location request timed out"));
              break;
            default:
              reject(new Error("An unknown error occurred"));
          }
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0,
        },
      );
    });
  }, []);

  // Function to save location and dispatch pincode to Redux
  const saveLocationAndDispatch = useCallback(
    (locationData) => {
      const displayText =
        locationData.shortAddress || locationData.area || locationData.city;
      const displayLocation = locationData.pincode
        ? `${displayText}, ${locationData.pincode}`
        : displayText;

      setSelectedLocation(displayLocation);
      localStorage.setItem("userLocation", JSON.stringify(locationData));

      // Dispatch pincode to Redux for API usage
      if (locationData.pincode) {
        dispatch(setPincode(locationData.pincode));
      }

      return locationData;
    },
    [dispatch],
  );

  const autoFetchLocation = useCallback(async () => {
    if (locationFetchedRef.current) return;

    const savedLocation = localStorage.getItem("userLocation");
    if (savedLocation) {
      try {
        const loc = JSON.parse(savedLocation);
        if (loc.pincode) {
          saveLocationAndDispatch(loc);
          locationFetchedRef.current = true;
          return;
        }
      } catch (error) {
        console.error("Error parsing saved location:", error);
      }
    }

    setLocationLoading(true);
    try {
      const locationData = await getCurrentLocationAndPincode();
      saveLocationAndDispatch(locationData);
      setSnackbar({
        open: true,
        message: `Location detected: ${locationData.shortAddress || locationData.area || locationData.city}`,
        severity: "success",
      });
      locationFetchedRef.current = true;
    } catch (error) {
      console.error("Auto location fetch failed:", error);
      setSelectedLocation("Location unavailable");
      setSnackbar({
        open: true,
        message:
          error.message || "Please manually select your location to continue",
        severity: "warning",
      });
    } finally {
      setLocationLoading(false);
    }
  }, [getCurrentLocationAndPincode, saveLocationAndDispatch]);

  useEffect(() => {
    autoFetchLocation();
  }, [autoFetchLocation]);

  const handleCheckout = (cartItems, totals) => {
    console.log("Proceeding to checkout with:", { cartItems, totals });
  };

  useEffect(() => {
    const tryShowPopup = () => {
      const raw = localStorage.getItem("showOrderSuccessPopup");
      if (!raw) return;

      try {
        const { orderNumber, timestamp } = JSON.parse(raw);
        if (Date.now() - timestamp < 60_000 && orderNumber) {
          localStorage.removeItem("showOrderSuccessPopup");
          setPopupOrderNumber(orderNumber);
          setShowOrderPopup(true);
          popupTimerRef.current = setTimeout(() => {
            setShowOrderPopup(false);
            setPopupOrderNumber(null);
          }, 12_000);
        } else {
          localStorage.removeItem("showOrderSuccessPopup");
        }
      } catch {
        localStorage.removeItem("showOrderSuccessPopup");
      }
    };

    const raf = requestAnimationFrame(tryShowPopup);

    return () => {
      cancelAnimationFrame(raf);
      if (popupTimerRef.current) clearTimeout(popupTimerRef.current);
    };
  }, []);

  const handleCloseOrderPopup = () => {
    if (popupTimerRef.current) clearTimeout(popupTimerRef.current);
    setShowOrderPopup(false);
    setPopupOrderNumber(null);
  };

  const fetchCartCount = useCallback(
    async (forceRefresh = false) => {
      if (!isAuthenticated) return;
      if (!forceRefresh && cartFetchedRef.current) return;

      const token = localStorage.getItem("authToken");
      if (!token) {
        setIsAuthenticated(false);
        setCartCount(0);
        return;
      }

      if (!forceRefresh) {
        cartFetchedRef.current = true;
      }

      try {
        const { getCartItems } =
          await import("../../../services/api/cartService");
        const response = await getCartItems();
        console.log("Cart items response:", response);
        console.log("Cart items response:", response?.data?.data?.length);
        if (response.data?.success && response.data?.data) {
          const totalQuantity = response.data.data.reduce(
            (sum, item) => sum + item.quantity,
            0,
          );
          const totalItems = response?.data?.data?.length;
          console.log("Fetched cart count:", totalItems);
          setCartCount(totalItems);
        }
      } catch (error) {
        console.error("Error fetching cart count:", error);
        if (error.response?.status === 401) {
          cartFetchedRef.current = false;
          setIsAuthenticated(false);
          setCartCount(0);
          window.dispatchEvent(new Event("auth-logout"));
        } else {
          cartFetchedRef.current = false;
        }
      }
    },
    [isAuthenticated],
  );

  useEffect(() => {
    if (isAuthenticated && !cartFetchedRef.current) {
      fetchCartCount();
    }
  }, [isAuthenticated, fetchCartCount]);

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    const refreshToken = localStorage.getItem("refreshToken");
    const storedUser = localStorage.getItem("user");

    if (token && storedUser) {
      setIsAuthenticated(true);
      if (refreshToken) {
        dispatch(setRefreshToken(refreshToken));
      }
      cartFetchedRef.current = false;
      try {
        const userData = JSON.parse(storedUser);
        setUserName(userData.name || userData.user || "User");
        dispatch(setUser(userData));
        dispatch(setToken(token));
        fetchCartCount(true);
      } catch (error) {
        console.error("Error parsing user data:", error);
      }
    } else {
      if (isAuthenticated) {
        setIsAuthenticated(false);
        setUserName("");
        setCartCount(0);
        cartFetchedRef.current = false;
      }
    }
  }, [dispatch, fetchCartCount]);

  useEffect(() => {
    const handleStorageChange = () => {
      const token = localStorage.getItem("authToken");
      const storedUser = localStorage.getItem("user");

      if (!token || !storedUser) {
        setIsAuthenticated(false);
        setUserName("");
        setCartCount(0);
        cartFetchedRef.current = false;
      }
    };

    window.addEventListener("storage", handleStorageChange);

    const handleLogoutEvent = () => {
      handleStorageChange();
    };
    window.addEventListener("auth-logout", handleLogoutEvent);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("auth-logout", handleLogoutEvent);
    };
  }, []);

  useEffect(() => {
    if (CATEGORIES.length === 0) return;
    const segments = location.pathname.split("/").filter(Boolean);
    if (segments[0] === "category" && segments[1]) {
      const catSlug = segments[1];
      const cat = CATEGORIES.find((c) => c.slug === catSlug);
      if (cat && (!selectedCategory || selectedCategory.slug !== catSlug)) {
        setActiveCategory(cat.label);
        setSelectedCategory(cat);
      }
    } else if (location.pathname === "/") {
      setActiveCategory(null);
      setSelectedCategory(null);
      setSelectedSubcategory(null);
      setSelectedSubSubcategory(null);
      setSubSubcategories([]);
    }
    prevPathRef.current = location.pathname;
  }, [location.pathname, CATEGORIES]);

  useEffect(() => {
    if (location.pathname.startsWith("/product/")) {
      if (contentRef.current) {
        contentRef.current.scrollTop = 0;
      }
      window.scrollTo(0, 0);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
    if (search.trim().length < 2) {
      setSearchResults([]);
      setSearchOpen(false);
      return;
    }
    searchTimeoutRef.current = setTimeout(async () => {
      setSearchLoading(true);
      setSearchOpen(true);
      const results = await searchService.search(search, 10, true);
      setSearchResults(results);
      setSearchLoading(false);
    }, 500);
    return () => {
      if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
    };
  }, [search]);

  const handleSearchScroll = useCallback(
    async (e) => {
      const el = e.target;
      const isAtBottom = el.scrollHeight - el.scrollTop <= el.clientHeight + 50;
      if (isAtBottom && !searchLoading && searchService.getHasMore()) {
        setSearchLoading(true);
        const newResults = await searchService.loadMore();
        setSearchResults(newResults);
        setSearchLoading(false);
      }
    },
    [searchLoading],
  );

  const scroll = (dir) => {
    const el = scrollRef.current;
    if (!el) return;
    el.scrollBy({ left: dir === "right" ? 280 : -280, behavior: "smooth" });
  };
  const handleScroll = () => {
    if (scrollRef.current) setScrollPos(scrollRef.current.scrollLeft);
  };
  const canScrollLeft = scrollPos > 10;
  const canScrollRight = scrollRef.current
    ? scrollPos <
      scrollRef.current.scrollWidth - scrollRef.current.clientWidth - 10
    : true;

  const handleSignInClick = () => {
    SignInLayout.open({
      onSuccess: (userData) => {
        console.log("SignIn success, userData:", userData);
        cartFetchedRef.current = false;
        localStorage.setItem("isAuthenticated", "true");
        localStorage.setItem(
          "userName",
          userData.user || userData.userData?.name || "User",
        );
        fetchCartCount(true);
      },
    });
  };

  const handleProfileClick = (e) => setAnchorEl(e.currentTarget);
  const handleProfileClose = () => setAnchorEl(null);

  const handleLogout = () => {
    dispatch(logout());
    dispatch(clearPincode());
    setIsAuthenticated(false);
    setUserName("");
    setAnchorEl(null);
    setCartCount(0);
    cartFetchedRef.current = false;
    setSelectedLocation("Detecting location...");
    locationFetchedRef.current = false;

    const itemsToRemove = [
      "authToken",
      "refreshToken",
      "user",
      "isAuthenticated",
      "userName",
      "userLocation",
      "cart",
      "selectedAddress",
    ];

    itemsToRemove.forEach((item) => localStorage.removeItem(item));
    sessionStorage.clear();
    setSearch("");
    setSearchResults([]);
    setSearchOpen(false);
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }
    searchService.reset();
    setActiveCategory(null);
    setSelectedCategory(null);
    setSelectedSubcategory(null);
    setSelectedSubSubcategory(null);
    setSubSubcategories([]);
    window.dispatchEvent(new Event("auth-logout"));
    navigate("/");
    setSnackbar({
      open: true,
      message: "Successfully logged out. Your location data has been cleared.",
      severity: "success",
    });
  };

  const getInitials = (name) => {
    if (!name) return "U";
    const t = name.trim();
    return t.length <= 1 ? t.toUpperCase() : t.substring(0, 2).toUpperCase();
  };

  const handleLogoClick = useCallback(() => {
    setActiveCategory(null);
    setSelectedCategory(null);
    setSelectedSubcategory(null);
    setSelectedSubSubcategory(null);
    setSubSubcategories([]);
    navigate("/");
  }, [navigate]);

  const handleCategoryClick = useCallback(
    (category) => {
      setSelectedSubcategory(null);
      setSelectedSubSubcategory(null);
      setSubSubcategories([]);
      setActiveCategory(category.label);
      setSelectedCategory(category);
      navigate(`/category/${category.slug}`);
    },
    [navigate],
  );

  const handleSubcategorySelect = useCallback(
    (subcategory) => {
      setSelectedSubSubcategory(null);
      setSubSubcategories([]);
      setSelectedSubcategory(subcategory);
      if (selectedCategory) {
        navigate(
          `/category/${selectedCategory.slug}/${slugify(subcategory.name)}`,
        );
      }
    },
    [selectedCategory, navigate],
  );

  const handleSubSubcategorySelect = useCallback(
    (subSubcategory) => {
      if (!subSubcategory) {
        setSelectedSubSubcategory(null);
        return;
      }
      setSelectedSubSubcategory(subSubcategory);
      if (selectedCategory && selectedSubcategory) {
        const newPath = `/category/${selectedCategory.slug}/${slugify(selectedSubcategory.name)}/${slugify(subSubcategory.name)}`;
        if (location.pathname !== newPath) navigate(newPath);
      }
    },
    [selectedCategory, selectedSubcategory, location.pathname, navigate],
  );

  const handleSubSubcategoriesLoaded = useCallback((list) => {
    setSubSubcategories(list);
  }, []);

  const getActiveCategoryId = () => {
    if (selectedSubSubcategory) return selectedSubSubcategory.id;
    if (selectedSubcategory && !selectedSubcategory.hasChildren)
      return selectedSubcategory.id;
    return null;
  };

  const handleProductClickFromSearch = (product) => {
    if (contentRef.current) {
      contentRef.current.scrollTop = 0;
    }
    window.scrollTo({ top: 0, behavior: "instant" });
    setSearchOpen(false);
    setSearch("");
    setSearchResults([]);
    navigate(`/product/${product.id}`);
  };

  const handleProductClick = (uuid) => {
    if (contentRef.current) {
      contentRef.current.scrollTop = 0;
    }
    window.scrollTo({ top: 0, behavior: "instant" });
    navigate(`/product/${uuid}`);
  };

  const handleVendorBack = () => {
    navigate(-1);
  };

  const handleLocationSelect = (loc) => {
    console.log("Manually selected location:", loc);
    const displayText = loc.shortAddress || loc.area || loc.city;
    const displayLocation = loc.pincode
      ? `${displayText}, ${loc.pincode}`
      : displayText;
    setSelectedLocation(displayLocation);
    localStorage.setItem("userLocation", JSON.stringify(loc));
    if (loc.pincode) {
      dispatch(setPincode(loc.pincode));
    }
  };

  const handleManualLocationRetry = () => {
    setCurrentLocationOpen(true);
  };

  const isProductPage = location.pathname.startsWith("/product/");
  const showBanner =
    !selectedCategory &&
    !isProductPage &&
    !isVendorPage &&
    location.pathname === "/";
  const [cartRefreshKey, setCartRefreshKey] = useState(0);

  const handleCartOpen = useCallback(() => {
    console.log("Cart button clicked - fetching fresh cart data");
    if (isAuthenticated) {
      fetchCartCount(true); // Pass true to force refresh
      setCartRefreshKey((prev) => prev + 1);
    }
    setCartDrawerOpen(true);
  }, [isAuthenticated, fetchCartCount]);

  const handleVendorSelect = (vendorId) => {
    console.log("Selected vendor:", vendorId);
  };

  const handleProductSelect = (productUuid) => {
    navigate(`/product/${productUuid}`);
  };

  return (
    <Box
      sx={{
        fontFamily: '"Nunito", sans-serif',
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        overflow: "hidden",
      }}
    >
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      <GlassAppBar position="static" elevation={0} sx={{ flexShrink: 0 }}>
        <Toolbar
          sx={{ px: { xs: 1, md: 3 }, gap: 1, minHeight: { xs: 60, md: 70 } }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              mr: 1,
              cursor: "pointer",
            }}
            onClick={handleLogoClick}
          >
            <img
              src={Logo}
              alt="zippshoppe"
              style={{ width: 78, height: 76 }}
            />
          </Box>

          <ClickAwayListener onClickAway={() => setSearchOpen(false)}>
            <Box sx={{ position: "relative", flexGrow: 1, margin: "0 16px" }}>
              <SearchBar ref={searchAnchorRef}>
                <SearchIcon sx={{ ml: 2, color: "black", fontSize: 20 }} />
                <InputBase
                  placeholder="Search for groceries, electronics..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  onFocus={() =>
                    searchResults.length > 0 && setSearchOpen(true)
                  }
                  sx={{
                    color: "black",
                    ml: 1,
                    flex: 1,
                    "& input::placeholder": { color: "black" },
                    pr: 2,
                  }}
                />
                {search && (
                  <IconButton
                    size="small"
                    onClick={() => {
                      setSearch("");
                      setSearchResults([]);
                      setSearchOpen(false);
                      searchService.reset();
                    }}
                    sx={{ color: "black", mr: 0.5 }}
                  >
                    <Close fontSize="small" />
                  </IconButton>
                )}
              </SearchBar>

              <Popper
                open={searchOpen && (searchResults.length > 0 || searchLoading)}
                anchorEl={searchAnchorRef.current}
                placement="bottom-start"
                transition
                sx={{
                  width: searchAnchorRef.current?.clientWidth,
                  zIndex: 1300,
                }}
              >
                {({ TransitionProps }) => (
                  <Fade {...TransitionProps} timeout={350}>
                    <Paper
                      elevation={3}
                      ref={resultsContainerRef}
                      onScroll={handleSearchScroll}
                      sx={{
                        mt: 1,
                        maxHeight: 400,
                        overflow: "auto",
                        borderRadius: 2,
                        border: "1px solid #e0e0e0",
                      }}
                    >
                      {searchLoading && searchResults.length === 0 ? (
                        <Box sx={{ p: 3, textAlign: "center" }}>
                          <CircularProgress size={30} />
                          <Typography sx={{ mt: 1, color: "#666" }}>
                            Searching...
                          </Typography>
                        </Box>
                      ) : (
                        <>
                          <List sx={{ p: 1 }}>
                            {searchResults.map((item) => (
                              <SearchResultItem
                                key={item.id}
                                item={item}
                                onClick={handleProductClickFromSearch}
                              />
                            ))}
                          </List>
                          {searchLoading && searchResults.length > 0 && (
                            <Box sx={{ p: 2, textAlign: "center" }}>
                              <CircularProgress size={25} />
                              <Typography
                                variant="caption"
                                sx={{ display: "block", mt: 0.5 }}
                              >
                                Loading more...
                              </Typography>
                            </Box>
                          )}
                          {!searchLoading &&
                            searchResults.length === 0 &&
                            search.length >= 2 && (
                              <Box sx={{ p: 3, textAlign: "center" }}>
                                <Typography sx={{ color: "#666" }}>
                                  No products found for "{search}"
                                </Typography>
                              </Box>
                            )}
                        </>
                      )}
                    </Paper>
                  </Fade>
                )}
              </Popper>
            </Box>
          </ClickAwayListener>

          <Tooltip title="Your Cart" arrow>
            <CartButton
              size="medium"
              sx={{ ml: 0.5 }}
              // onClick={() => setCartDrawerOpen(true)}
              onClick={handleCartOpen}
            >
              <Badge
                badgeContent={cartCount}
                sx={{
                  "& .MuiBadge-badge": {
                    background:
                      "linear-gradient(135deg, #ff6b35 0%, #f7931e 100%)",
                    color: "#fff",
                    fontWeight: 700,
                    fontSize: 11,
                    minWidth: 18,
                    height: 18,
                  },
                }}
              >
                <ShoppingCartOutlined sx={{ color: "#3a2e00", fontSize: 22 }} />
              </Badge>
            </CartButton>
          </Tooltip>

          <CartDrawer
            key={cartRefreshKey}
            open={cartDrawerOpen}
            onClose={() => setCartDrawerOpen(false)}
            onCheckout={handleCheckout}
            refreshCart={cartRefreshKey}
          />

          {!isAuthenticated ? (
            <SignInButton
              onClick={handleSignInClick}
              startIcon={<PersonOutline sx={{ fontSize: "18px !important" }} />}
              sx={{ ml: 1 }}
            >
              Sign In
            </SignInButton>
          ) : (
            <>
              <ProfileButton onClick={() => setProfileDrawerOpen(true)}>
                <StyledAvatar>{getInitials(userName)}</StyledAvatar>
                <KeyboardArrowDownRounded
                  sx={{ fontSize: 16, color: "#3a2e00" }}
                />
              </ProfileButton>
              <ConsumerProfile
                open={profileDrawerOpen}
                onClose={() => setProfileDrawerOpen(false)}
                userName={userName}
                userEmail={user?.email || ""}
                userPhone={user?.phoneNumber || ""}
                onLogout={() => {
                  // Additional logout logic if needed
                  setProfileDrawerOpen(false);
                }}
              />
            </>
          )}
        </Toolbar>
      </GlassAppBar>

      <DeliveryBar sx={{ flexShrink: 0 }}>
        <LocationChip onClick={() => setCurrentLocationOpen(true)}>
          {locationLoading ? (
            <CircularProgress size={14} sx={{ color: "#071233" }} />
          ) : (
            <LocationOnOutlined sx={{ fontSize: 15, color: "#071233" }} />
          )}
          Deliver to:&nbsp;
          <span
            style={{
              color: "#071233",
              fontWeight: 700,
              maxWidth: 350,
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {selectedLocation.split(",")[0]} - {zipcode || ""}
          </span>
          <KeyboardArrowDownRounded sx={{ fontSize: 16, ml: 0.5 }} />
        </LocationChip>
      </DeliveryBar>

      <CurrentLocation
        open={currentLocationOpen}
        onClose={() => setCurrentLocationOpen(false)}
        onLocationSelect={handleLocationSelect}
      />

      {!isVendorPage && (
        <Box
          sx={{
            background: "#ffffff",
            borderBottom: "2px solid #f0f0f0",
            boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
            flexShrink: 0,
          }}
        >
          <Box sx={{ position: "relative" }}>
            {canScrollLeft && (
              <IconButton
                onClick={() => scroll("left")}
                size="small"
                sx={{
                  position: "absolute",
                  left: 4,
                  top: "50%",
                  transform: "translateY(-50%)",
                  zIndex: 10,
                  background: "#fff",
                  boxShadow: "0 2px 12px rgba(0,0,0,0.15)",
                  width: 32,
                  height: 32,
                  "&:hover": {
                    background: "#fff",
                    boxShadow: "0 4px 18px rgba(0,0,0,0.2)",
                  },
                }}
              >
                <ChevronLeft sx={{ fontSize: 18, color: "#333" }} />
              </IconButton>
            )}
            <Box
              ref={scrollRef}
              onScroll={handleScroll}
              sx={{
                display: "flex",
                overflowX: "auto",
                scrollbarWidth: "none",
                "&::-webkit-scrollbar": { display: "none" },
                px: 4,
                py: 0.5,
                gap: 0.5,
              }}
            >
              {CATEGORIES.map((cat) => {
                const isActive = activeCategory === cat.label;
                return (
                  <Box
                    key={cat.id || cat.label}
                    onClick={() => handleCategoryClick(cat)}
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 1,
                      px: 1.5,
                      py: 0.8,
                      borderRadius: 3,
                      cursor: "pointer",
                      flexShrink: 0,
                      minWidth: "auto",
                      transition: "all 0.22s ease",
                      background: isActive ? cat.color : "transparent",
                      borderBottom: isActive
                        ? `3px solid ${cat.border}`
                        : "3px solid transparent",
                      transform: isActive ? "translateY(-1px)" : "none",
                      "&:hover": {
                        background: cat.color,
                        transform: "translateY(-2px)",
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: 50,
                        height: 50,
                        borderRadius: "50%",
                        background: isActive ? cat.color : "#f7f7f7",
                        border: `2.5px solid ${isActive ? cat.border : "#efefef"}`,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: 22,
                        boxShadow: isActive
                          ? `0 4px 12px ${cat.border}55`
                          : "0 1px 4px rgba(0,0,0,0.07)",
                        transition: "all 0.22s ease",
                        overflow: "hidden",
                      }}
                    >
                      {cat.imageUrl ? (
                        <img
                          src={cat.imageUrl}
                          alt={cat.label}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: "50%",
                          }}
                        />
                      ) : (
                        cat.emoji
                      )}
                    </Box>
                    <Typography
                      sx={{
                        fontSize: 13,
                        fontWeight: isActive ? 800 : 500,
                        fontFamily: '"Nunito", sans-serif',
                        color: isActive ? "#1a1a1a" : "#666",
                        textAlign: "center",
                        lineHeight: 1.3,
                        whiteSpace: "nowrap",
                      }}
                    >
                      {cat.label}
                    </Typography>
                  </Box>
                );
              })}
            </Box>
            {canScrollRight && (
              <IconButton
                onClick={() => scroll("right")}
                size="small"
                sx={{
                  position: "absolute",
                  right: 4,
                  top: "50%",
                  transform: "translateY(-50%)",
                  zIndex: 10,
                  background: "#fff",
                  boxShadow: "0 2px 12px rgba(0,0,0,0.15)",
                  width: 32,
                  height: 32,
                  "&:hover": {
                    background: "#fff",
                    boxShadow: "0 4px 18px rgba(0,0,0,0.2)",
                  },
                }}
              >
                <ChevronRight sx={{ fontSize: 18, color: "#333" }} />
              </IconButton>
            )}
          </Box>
        </Box>
      )}

      {showOrderPopup && popupOrderNumber && (
        <OrderSuccessPopup
          orderNumber={popupOrderNumber}
          onClose={handleCloseOrderPopup}
        />
      )}

      {isVendorPage && vendorId ? (
        <Box ref={contentRef} sx={{ flex: 1, overflowY: "auto" }}>
          <VendorCategoryPage
            vendorId={vendorId}
            vendorName={vendorName}
            onBack={handleVendorBack}
            onProductClick={handleProductClick}
          />
        </Box>
      ) : isProductPage ? (
        <Box ref={contentRef} sx={{ flex: 1, overflowY: "auto" }}>
          {children}
        </Box>
      ) : !isProductPage && selectedCategory ? (
        <Box
          ref={contentRef}
          sx={{
            flex: 1,
            overflowY: "auto",
            "&::-webkit-scrollbar": { width: "6px" },
            "&::-webkit-scrollbar-track": { background: "#f5f5f5" },
            "&::-webkit-scrollbar-thumb": {
              background: "#d0d0d0",
              borderRadius: 10,
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              maxWidth: 1300,
              width: "100%",
              margin: "12px auto",
              background: "#FEFEFE",
              borderRadius: "16px",
              boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
            }}
          >
            {selectedSubcategory?.hasChildren &&
              subSubcategories.length > 0 && (
                <Box
                  sx={{
                    flexShrink: 0,
                    background: "#FAFAFA",
                    borderBottom: "1px solid #eaeef5",
                    borderRadius: "16px 16px 0 0",
                    overflow: "hidden",
                  }}
                >
                  <Box
                    sx={{
                      p: 1.5,
                      display: "flex",
                      gap: 1.5,
                      flexWrap: "wrap",
                      alignItems: "center",
                    }}
                  >
                    {subSubcategories.map((subSub) => {
                      const isActive = selectedSubSubcategory?.id === subSub.id;
                      return (
                        <Chip
                          key={subSub.id}
                          label={subSub.name}
                          onClick={() => handleSubSubcategorySelect(subSub)}
                          avatar={
                            subSub.imageUrl ? (
                              <Box
                                component="img"
                                src={subSub.imageUrl}
                                sx={{
                                  width: 24,
                                  height: 24,
                                  borderRadius: "50%",
                                  objectFit: "cover",
                                }}
                              />
                            ) : undefined
                          }
                          sx={{
                            py: 2.5,
                            px: 1,
                            fontSize: 13,
                            fontWeight: isActive ? 700 : 600,
                            bgcolor: isActive ? "#f7d261" : "#fff",
                            color: isActive ? "#0f4c81" : "#666",
                            border: `1px solid ${isActive ? "#f7d261" : "#e0e0e0"}`,
                            cursor: "pointer",
                            transition: "all 0.2s ease",
                            "&:hover": {
                              bgcolor: isActive ? "#f7d261" : "#f5f5f5",
                              transform: "translateY(-1px)",
                              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                            },
                          }}
                        />
                      );
                    })}
                  </Box>
                </Box>
              )}

            <Box sx={{ display: "flex" }}>
              <Box
                sx={{
                  flexShrink: 0,
                  position: "sticky",
                  top: 0,
                  alignSelf: "flex-start",
                  maxHeight: "100vh",
                  overflowY: "auto",
                  "&::-webkit-scrollbar": { width: "3px" },
                  "&::-webkit-scrollbar-track": { background: "#f5f5f5" },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#e0e0e0",
                    borderRadius: 10,
                  },
                }}
              >
                <SubcategoryBar
                  key={`${selectedCategory?.id}-${activeCategory}`}
                  parentCategoryId={selectedCategory.id}
                  onSubcategorySelect={handleSubcategorySelect}
                  selectedSubcategoryId={selectedSubcategory?.id}
                  onSubSubcategorySelect={handleSubSubcategorySelect}
                  selectedSubSubcategoryId={selectedSubSubcategory?.id}
                  onSubSubcategoriesLoaded={handleSubSubcategoriesLoaded}
                />
              </Box>

              <Box sx={{ flex: 1 }}>
                <ProductsGrid
                  categoryId={getActiveCategoryId()}
                  onProductClick={handleProductClick}
                />
              </Box>
            </Box>
          </Box>

          <Footer />
        </Box>
      ) : (
        <Box ref={contentRef} sx={{ flex: 1, overflowY: "auto" }}>
          {showBanner && <GroceriesBannerSlider />}
          {zipcode && (
            <VendorShowcase
              postalCode={zipcode}
              onVendorSelect={handleVendorSelect}
              onProductSelect={handleProductSelect}
            />
          )}

          <Footer sx={{ mt: 20 }} />
        </Box>
      )}
    </Box>
  );
}

export default Header;
